import script from "./Training2024.vue?vue&type=script&setup=true&lang=js"
export * from "./Training2024.vue?vue&type=script&setup=true&lang=js"

import "./Training2024.vue?vue&type=style&index=0&id=63dd365c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63dd365c"]])

export default __exports__